export const showUntrustedNotice = (origin: string | null) => {
	const notice = document.createElement("div");
	notice.setAttribute("role", "alert");
	notice.textContent = `Превью: окно ${origin ?? "без адреса"} не входит в список доверенных — приложение отключено от бэкенда и не отправляет заказы.`;
	Object.assign(notice.style, {
		position: "fixed",
		zIndex: "2147483647",
		inset: "0 0 auto 0",
		padding: "8px 12px",
		background: "#fff6e0",
		color: "#8a5a00",
		font: "600 14px/1.4 system-ui, sans-serif",
		textAlign: "center",
		pointerEvents: "none",
	});
	const mount = () => document.body.appendChild(notice);
	if (document.body) mount();
	else document.addEventListener("DOMContentLoaded", mount, { once: true });
};
